import React from 'react';
import styled from 'styled-components';
import CheckboxField from 'gatsby-theme-core/src/components/form-elements/checkbox/index';
import spacer from 'gatsby-theme-core/src/components/form-elements/spacer';

const isChecked = (currentValue, value) => {
  if (Array.isArray([currentValue])) {
    return currentValue.includes(value);
  }
  return currentValue === value;
};

const Checkbox = ({
  className,
  currentValue = '',
  handler,
  options = [],
  withCount = false,
}) => (
  <div className={className}>
    {options.map(({ value, name, count }) => {
      const theValue = value || name;
      return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label key={name} css="display: block; cursor: pointer; margin-bottom: .5rem">
          <CheckboxField
            checked={isChecked(currentValue, theValue)}
            type="checkbox"
            value={theValue}
            onChange={handler}
          />
          {' '}
          <Span>{name}{withCount && count && ` (${count})`}</Span>
        </label>
      );
    })}
  </div>
);

// ::first-letter only works on block elements
const Span = styled.span`
  display: inline-block;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export default styled(Checkbox)`
  ${spacer}
`;
